import toast from "react-hot-toast";

function formataOperadoresRelacionaisV2(metaNumero, metaOperador, resultadoEmPorcentagem) {

    let stringFinal = null;

    const operadores = {
        '>=': '≥',
        '<=': '≤',
        '==': '',
    };

    const operador = operadores[metaOperador];

    if (metaNumero === 100) {
        stringFinal = `${metaNumero}`;
    } else {
        stringFinal = `${operador}${metaNumero}`;
    }

    if (resultadoEmPorcentagem) stringFinal += '%';

    return stringFinal;

}

function formatCPF(raw) {
    if (!raw && raw !== 0) return '';
    const s = String(raw).replace(/\D/g, ''); // Só dígitos
    if (s.length !== 11) return raw; // Se não tem 11 dígitos, retorna como veio (ou '' se preferir)
    return s.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

function toastErrorFromResponse(error) {
    console.error(error);
    toast.error(error.response?.data?.message || 'Erro inesperado');
}

const primeiraLetraMaiuscula = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

function formatBRL(value) {
    const finalValue = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
    return finalValue.format(value)
}

function formatResultadoIndicadorBRL(value, resultadoEmPorcentagem) {
    
    console.log('DEBUG');
    console.log(resultadoEmPorcentagem);

    if ( value  === 100 | value === 0) {
        return resultadoEmPorcentagem ? value + '%' : value
    }
    
    const finalValue = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
    
    return resultadoEmPorcentagem ? finalValue.format(value) + '%' : finalValue.format(value) 

}

const formatDataHoraBR = (isoString) => new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    dateStyle: 'short',
    timeStyle: 'short',
}).format(new Date(isoString));

// Para date puro (ex: "2026-07-16"), sem hora — parse manual pra evitar o bug de UTC
const formatDataBR = (dateString) => {
    const [ano, mes, dia] = dateString.split('-').map(Number);
    return `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${ano}`;
};

export {
    formataOperadoresRelacionaisV2,
    formatCPF,
    toastErrorFromResponse,
    primeiraLetraMaiuscula,
    formatBRL,
    formatResultadoIndicadorBRL,
    formatDataHoraBR,
    formatDataBR
}